import React, { useCallback, useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { translate } from 'services/i18nService';
import { NOTIFICATION_DISMISS_DELAY, NOTIFICATION_EXPAND_DELAY } from 'enum/achievementsSettings';

import ACHIEVEMENT_IMAGES from '../../../../images/achievements';
import { normalizeAchievementsStrings } from '../Utils';

import styles from './AchievementNotification.css';


const AchievementNotification = ({ id, name, onClick, onDismiss }) => {
  const [show, setShow] = useState(false);

  const achievements = useSelector((store) => store.itemsAchievements.achievementsUnlocked);

  useEffect(() => {
    setTimeout(() => setShow(true), NOTIFICATION_EXPAND_DELAY);
  }, []);

  useEffect(() => {
    setTimeout(() => onDismiss(id), NOTIFICATION_DISMISS_DELAY);
  }, [id, onDismiss]);

  const handleClick = useCallback(() => {
    const index = achievements.findIndex((element) => element.name === name);

    onClick(index);
  }, [onClick, name, achievements]);

  const handleDismiss = useCallback(() => {
    onDismiss(id);
  }, [onDismiss, id]);

  const renderNotification = useCallback(() => {
    if (!show) {
      return null;
    }

    return (
      <div className={styles.containerDescription}>
        <p className={styles.title} data-cy="notification_title">
          {translate(normalizeAchievementsStrings(name, 'title'))}
        </p>
        <span
          className={styles.achievementUnlocked}
          data-cy="notification_unlocked"
        >
          {translate('gamification.trophies.notification.unlocked')}
        </span>
      </div>
    );
  }, [name, show]);

  return (
    <div className={styles.container} data-cy={name}>
      <div className={styles.imageContainer} onClick={handleClick}>
        <div className={styles.background}>
          <img
            alt=""
            className={styles.image}
            data-cy="notification_img"
            src={ACHIEVEMENT_IMAGES[name?.toLowerCase()]}
          />
        </div>
      </div>

      {renderNotification()}

      <div className={styles.iconContainer}>
        <CloseIcon
          data-cy="notification_cros_icon"
          fontSize="small"
          onClick={handleDismiss}
        />
      </div>
    </div>
  );
};

AchievementNotification.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onDismiss: PropTypes.func,
};

AchievementNotification.defaultProps = {
  onClick: () => undefined,
  onDismiss: () => undefined,
};

export default AchievementNotification;
